import React, { Component } from 'react';
import { withStyles } from '@material-ui/styles';
import { useStyles } from './styles.js';
import { Grid, Typography, Button } from '@material-ui/core';
import Tier from './Tier';

class Select extends Component {
  constructor(props) {
    super(props);

    this.onSubmit = this.onSubmit.bind(this);
  }

  onSubmit() {
    this.props.isSubmitted();
  }


    render(){
        const { classes, numPlayer, numTier, tier, currentTier, changeTier, spots, ended, guest } = this.props;
        const maxThree = Math.max(...numPlayer) == 3;      
        const player = "Charley";
        let count = 0;
        if (tier){
            tier.forEach((t, _) => {
                count += t.length;
            })
        }
        let full = count == spots;

        return (
            <>
            <Typography className={classes.number}>
                {spots}
            </Typography>
            <Typography className={classes.descText}>
                Welcome {guest.guest_name}. You have {spots} roster spots to fill.
            </Typography>
            <Typography className={classes.descText}>
                Please select three from each tier to complete your team.
            </Typography>
            <Grid container spacing={1}>
                {
                [...Array(numTier)].map((_, i) => {
                    let t = tier[i] ? tier[i] : [...Array(numPlayer[i])];
                    return (
                        <Tier players={t} tierIndex={i} classes={classes} numPlayer={numPlayer} currentTier={currentTier} changeTier={changeTier} key={`tier${i}`} />
                    )
                })
                }
                <Grid item xs={maxThree ? 9 : 8} style={{paddingTop: '10px'}}>
                    <Button variant="contained" className={classes.fullButton}>Charley Hoffman</Button>
                </Grid>
                {
                    full ?
                    <Grid item xs={maxThree ? 9 : 8}>
                        <Button onClick={() => this.onSubmit()} variant="contained" className={classes.submit}>
                            { ended ? 'GO TO LEADERBOARD' : 'SUBMIT' }
                        </Button>
                    </Grid>
                    :
                    <></>
                }

            </Grid>
            </>
    );
  }
}

export default withStyles(useStyles)(Select);
